/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Date_Range_CustomInputs */



/**
* | output |
* | --- |
* | "Custom" |
*
* @param {Date_Range_CustomInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const date_range_custom = /** @type {((inputs?: Date_Range_CustomInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Date_Range_CustomInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Personnalisé")
	if (locale === "de") return /** @type {LocalizedString} */ ("Brauch")
	if (locale === "it") return /** @type {LocalizedString} */ ("Costume")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обычай")
	if (locale === "es") return /** @type {LocalizedString} */ ("Costumbre")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("风俗")
	if (locale === "ja") return /** @type {LocalizedString} */ ("カスタム")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रिवाज़")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Personalizado")
	return /** @type {LocalizedString} */ ("Custom")
});